import { z } from 'zod'

export const HolidayLevel = z.enum(['NATIONAL', 'STATE'])
export type HolidayLevel = z.infer<typeof HolidayLevel>
